/** Easing functions, all mapping t in [0,1] -> [0,1] (some overshoot). */

export type Ease = (t: number) => number;

export const linear: Ease = (t) => t;

export const easeOutCubic: Ease = (t) => 1 - Math.pow(1 - t, 3);
export const easeInCubic: Ease = (t) => t * t * t;
export const easeInOutCubic: Ease = (t) =>
  t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

export const easeOutQuart: Ease = (t) => 1 - Math.pow(1 - t, 4);
export const easeOutQuint: Ease = (t) => 1 - Math.pow(1 - t, 5);

export const easeOutExpo: Ease = (t) => (t >= 1 ? 1 : 1 - Math.pow(2, -10 * t));

/** Soft, organic "ink bloom" — quick rise, gentle settle. */
export const inkBloom: Ease = (t) => 1 - Math.pow(1 - t, 2.4);

export const easeOutBack = (s = 1.70158): Ease => {
  const c3 = s + 1;
  return (t) => 1 + c3 * Math.pow(t - 1, 3) + s * Math.pow(t - 1, 2);
};

export const easeOutElastic: Ease = (t) => {
  const c4 = (2 * Math.PI) / 3;
  if (t === 0 || t === 1) return t;
  return Math.pow(2, -10 * t) * Math.sin((t * 10 - 0.75) * c4) + 1;
};

/** Gentle settle with a small overshoot — used for reward pops. */
export const popSettle: Ease = easeOutBack(2.2);

export const clamp = (v: number, lo: number, hi: number): number =>
  v < lo ? lo : v > hi ? hi : v;

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;
